/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpLogger from 'mbp-logger';
import restClient from '../../app/helpers/restClient';
import Debouncer from '../../app/helpers/DynamicPricing/Debouncer';

const RESOURCE_ROOT_FACADE = '/acquisition';
const RESOURCE_PAGE_FACADE = '/pricing';
const RESOURCE_PAGE_ACTION = '/product';

const debouncer = new Debouncer(restClient);

const getPriceFromEngine = (wcEnv, jwtToken, payload, shouldBatch) => {
    const env = wcEnv;
    env.rootUri = RESOURCE_ROOT_FACADE;
    const resourcePage = `${RESOURCE_PAGE_FACADE}${RESOURCE_PAGE_ACTION}`;

    if (!shouldBatch) {
        return restClient.postFacade(env, resourcePage, jwtToken, payload)
            .then((response) => response);
    }

    return new Promise((resolve, reject) => {
        debouncer.addRequest(wcEnv, jwtToken, resourcePage, payload, (err, data) => {
            if (err !== null) {
                mbpLogger.logError({
                    appName: process.env.npm_package_name,
                    jsError: err,
                    message: `PriceDebouncer: error in callback... ${err.message}`,
                    payload,
                });
                reject(err);
                return;
            }
            resolve({ data });
        });
    });
};

export default getPriceFromEngine;
